import { IdTutorialStep } from "../../IdTutorialStep";
export var checkTutorialOpenQuestMenu = function (path) { return function (action, state$, dependencies) {
    if (action.tutorialStep === IdTutorialStep.checkNewQuest_clickShowMeButton) {
        return path;
    }
    if (action.tutorialStep === IdTutorialStep.collectQuestReward_clickCollectRewards) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/checks/checkTutorialOpenQuestMenu.ts
// module id = 2469
// module chunks = 3